module.exports = __webpack_public_path__ + "static/img/player_head_6.3662066.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_6.jpg
// module id = V44T
// module chunks = 1